import { FilterMatchMode } from '@openng/optimus-ui/api';

export function normalizeForSearch(text: string): string {
	// NFD splits accented characters into base + combining marks, which the diacritic strip then removes.
	return (text ?? '')
		.normalize('NFD')
		.replace(/\p{Diacritic}/gu, '')
		.toLocaleLowerCase('lt');
}

export function matchesAllTokens(value: string, query: string): boolean {
	const normalizedQuery = normalizeForSearch(query);
	if (normalizedQuery.trim().length === 0) {
		return true;
	}

	const normalizedValue = normalizeForSearch(value);
	return normalizedQuery
		.split(/\s+/)
		.filter((token) => token.length > 0)
		.every((token) => normalizedValue.includes(token));
}

export const SearchMatchMode = {
	TokenAnd: 'tokenAnd',
	Contains: FilterMatchMode.CONTAINS,
	StartsWith: FilterMatchMode.STARTS_WITH,
} as const;
export type SearchMatchMode = (typeof SearchMatchMode)[keyof typeof SearchMatchMode];
